import { DynamicTankIcon } from 'app/agriculture/routes/Tanks/TankIndicator/DynamicTankIcon';

import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import './TankIndicator.scss';

export function TankIndicator({ level }: { level: number | null }) {
    return (
        <div className="TankIndicator">
            <DynamicTankIcon level={level} />
            <StatDisplay name="Level" value={level} unit="%" decimalPlaces={1} />
        </div>
    );
}
